<div class="page-layout simple full-width">
    <!-- HEADER -->
    <div class="header p-24 pb-0" fxLayout="row" fxLayoutAlign="space-between center">

        <div *ngIf="!isLoading" fxLayout="column" fxLayoutAlign="center start" [@animate]="{value:'*',params:{delay:'100ms',x:'-25px'}}">
            <div class="h2 mt-5"> Sección: {{ item.title }} </div>
        </div>

        <button mat-button [routerLink]="'/' + pathUrlList" class="mt-0 mt-md-0">
            <mat-icon>arrow_back</mat-icon>
            <span>Volver</span>
        </button>
    </div>
    <!-- / HEADER -->

    <!-- CONTENT -->
    <div class="content p-24">

        <div class="mb-24" fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">

            <mat-progress-bar *ngIf="isLoading" mode="buffer"></mat-progress-bar>

            <!-- REACTIVE FORM EXAMPLE -->

            <div *ngIf="!isLoading" class="mat-card mat-elevation-z4 p-24" fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto" name="form">

                <ng-container *ngFor="let field of configFields">

                    <mat-form-field *ngIf="field.type == 'string'" appearance="outline" class="pl-4">
                        <mat-label>{{ field.title }}</mat-label>
                        <input matInput [name]="field.key" [(ngModel)]="item['data'][field.key]" />
                    </mat-form-field>

                    <mat-form-field  *ngIf="field.type == 'select'" appearance="outline" fxFlex="80">
                        <mat-label>{{ field.title }}</mat-label>
                        <mat-select name="parent_id" [(ngModel)]="item['data'][field.key]">
                            <mat-option *ngFor="let opt of field.options" [value]="opt.value">
                                {{ opt.title }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field *ngIf="field.type == 'text'" appearance="outline" class="pl-4">
                        <mat-label>{{ field.title }}</mat-label>
                        <textarea matInput [name]="field.key" [(ngModel)]="item['data'][field.key]"></textarea>
                    </mat-form-field>

                    <div *ngIf="field.type == 'list'" class="pl-4" style="margin-bottom: 20px;" fxLayout="column">
                        <p style="margin-top: 16px;">Listado:</p>
                        <mat-card *ngFor="let section of item['data']['list']; let indexS = index" fxLayout="column" style="margin-bottom: 20px;">
                            <mat-form-field appearance="outline" class="pl-4">
                                <input matInput [name]="'list' + indexS" [(ngModel)]="section.title" placeholder="Titulo del bloque" />
                            </mat-form-field>

                            <ng-container *ngFor="let intern of section.items; let indexIn = index">
                                <mat-form-field appearance="outline" class="pl-4 no-margin-mobile" style="margin-left: 30px;">
                                    <input matInput [name]="'item_title' + indexIn" [(ngModel)]="intern.title" placeholder="Titulo del Sub bloque" />
                                </mat-form-field>
                                <mat-form-field appearance="outline" class="pl-4 no-margin-mobile" style="margin-left: 30px;">
                                    <textarea rows="6" matInput [name]="'item_caption' + indexIn" [(ngModel)]="intern.caption"></textarea>
                                </mat-form-field>
                            </ng-container>

                            <a (click)="addBoxIntern(section)" style="text-align: right;">Agregar item!</a>
                        </mat-card>
                        <a (click)="addBox()" style="margin-top: 16px;">Agregar bloque!</a>
                    </div>

                </ng-container>

                <!--<mat-form-field appearance="outline" fxFlex="80">
                    <mat-label>Seleccionar padre:</mat-label>
                    <mat-select name="parent_id" [(ngModel)]="category.parent_id">
                        <mat-option [value]="0">Ninguno</mat-option>
                        <mat-option *ngFor="let comp of categories" [value]="comp.id">
                            {{ comp.title }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>-->

                

                <mat-progress-bar *ngIf="isSending" mode="buffer"></mat-progress-bar>

                <div *ngIf="!isSending" fxLayout="row" fxLayout.xs="row wrap" fxLayoutAlign="start center" fxFlex="1 0 auto">
                    <button fxFlex.xs="100%" [routerLink]="'/' + pathUrlList" mat-raised-button color="warn" class="mt-24 mt-md-0 mr-4">
                        <span>Cancelar</span>
                    </button>

                    <button fxFlex.xs="100%" type="button" (click)="onClickSave()" mat-raised-button color="primary" class="mt-24 mt-md-0">
                        <span>Guardar y volver</span>
                    </button>
                </div>



            </div>

            <!-- / REACTIVE FORM EXAMPLE -->

        </div>

    </div>
    <!-- / CONTENT -->
</div>